import { ViewMode } from "./constants/enum.pos";

export interface UserDataView {
	user: User;
	viewMode: ViewMode;
}

export interface UserTypeDataView {
	userType: UserType;
	viewMode: ViewMode;
}

export class User {
	id: string = null;
	phoneNo: string = null;
	ssn: string = null;
	firstName: string = null;
	lastName: string = null;
	secretKey: string = null;
	confirmSecretKey: string = null;
	costPerHour: string = null;
	roleName: string = null;
	roleId: string | number = null;
	userType: number = null;
	isDriver: boolean = false;
	isLockedOut: boolean = false;
	defaultLanguage: string = null;
	autoLogoffInSecond: number = null;
}

export interface UserType {
	id: string;
	name: string;
	permissions: Permission[];
}

export interface Permission {
	code: string;
	name: string;
	isActive: boolean;
}

export interface Role {
	id: string;
	name: string;
}

export interface Gratuity {
	firstName: string;
	lastName: string;
	ticketId: number;
	amount: number;
}

export class UserInfo {
	access_token: string;
	expiresIn: number;
	refreshToken: string;
	tokenType: string;
	firstName: string;
	lastName: string;
}
